export const getToothMovementPercentage = ({ currentProgress, totalPlannedMovement }) => {
  if (!Number.isFinite(currentProgress) || !Number.isFinite(totalPlannedMovement) || totalPlannedMovement <= 0) {
    return null
  }

  const progress = 1 - Math.abs(totalPlannedMovement - currentProgress) / totalPlannedMovement
  if (!Number.isFinite(progress)) return null
  return Math.max(0, progress * 100).toFixed(0)
}
